import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import profileLogo from "../../assets/images/dashboard.jpg";
import dashboard from "../../assets/icons/Dashboard.png";
import menu from "../../assets/icons/menu.png";
import user from "../../assets/icons/user.png";
import addUser from "../../assets/icons/add-user.png";
import category from "../../assets/icons/category.png";
import logout from "../../assets/icons/logout.png";
import chef from "../../assets/icons/chef-suggestion.png";
import contact from "../../assets/icons/contact-list.png";
import dish1 from "../../assets/icons/dish (1).png";
import axios from "axios";

const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State for controlling dropdown visibility
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // State for controlling sidebar visibility
  const [admin, isAdmin] = useState(false); // State for storing admin status
  const navigate = useNavigate(); // Hook for navigation
  const [userName, setUserName] = useState(false); // State for storing the username

  const toggleDropdown = () => {
    // Function to toggle the dropdown visibility
    setIsDropdownOpen(!isDropdownOpen); // Toggle the state of dropdown visibility
  };

  const toggleSidebar = () => {
    // Function to toggle the sidebar visibility
    setIsSidebarOpen(!isSidebarOpen); // Toggle the state of sidebar visibility
  };

  const handleLogout = () => {
    // Function to handle user logout
    localStorage.removeItem("token"); // Remove token from local storage
    localStorage.removeItem("admin"); // Remove admin status from local storage
    localStorage.removeItem("name"); // Remove user name from local storage
    navigate("/login"); // Redirect to login page
  };

  const fetchDataValid = async () => {
    // Async function to validate the token and fetch user data
    const token = localStorage.getItem("token"); // Get the token from local storage

    if (!token) {
      // Check if token exists
      navigate("/login"); // Redirect to login if no token is found
      return; // Exit the function
    }

    try {
      const response = await axios.post(
        // Make an API request to validate the token
        `${process.env.REACT_APP_SERVER}/api/auth/validateToken`, // API endpoint to validate the token
        {}, // Empty body as we only need headers
        {
          headers: {
            // Set the headers for the request
            Authorization: `Bearer ${token}`, // Add the token in Authorization header
          },
        }
      );
      if (response.data.isValid) {
        // Check if the token is valid
        if (response.data.isAdmin) {
          // Check if the user is an admin
          const name = localStorage.getItem("name"); // Get the username from local storage
          setUserName(name); // Set the username in the state
          isAdmin(true); // Set admin status to true
          return; // Exit the function if the user is an admin
        } else {
          return; // Exit the function if the user is not an admin
        }
      } else {
        navigate("/login"); // Redirect to login if the token is invalid
      }
    } catch (error) {
      // Catch any errors during the API request
      console.error("Error during token validation:", error); // Log the error
      navigate("/login"); // Redirect to login if there's an error
    }
  };

  useEffect(() => {
    // UseEffect hook to run the token validation when the component mounts
    fetchDataValid(); // Call the fetchDataValid function
  }, []); // Empty dependency array to run the effect only once on mount

  return (
    <div>
      {/* Navbar */}
      <nav className="fixed top-0 z-50 w-full bg-white border-b border-gray-200 dark:bg-gray-900 dark:border-gray-900">
        <div className="px-3 py-3 lg:px-5 lg:pl-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-start">
              <button
                onClick={toggleSidebar}
                type="button"
                className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              >
                <span className="sr-only">Open sidebar</span>
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    clipRule="evenodd"
                    fillRule="evenodd"
                    d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                  />
                </svg>
              </button>
              <a href="/" className="flex ms-2 md:me-24">
                <span className="self-center text-xl font-semibold sm:text-2xl whitespace-nowrap dark:text-white">
                  Cavallo Bianco
                </span>
              </a>
            </div>
            <div className="flex items-center lg:mr-20 md:mr-40 sm:mr-8">
              <button
                onClick={toggleDropdown}
                type="button"
                className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
                aria-expanded="false"
              >
                <span className="sr-only">Open user menu</span>
                {userName ? (
                  <div className="flex items-center space-x-2">
                    <div className="w-8 h-8 bg-blue-500 text-white flex items-center justify-center rounded-full">
                      {userName.charAt(0).toUpperCase()}
                    </div>
                    <p className="text-sm font-medium text-gray-900 dark:text-white">
                      {userName.split(" ")[0]}
                    </p>
                  </div>
                ) : (
                  <img
                    className="w-8 h-8 rounded-full"
                    src={profileLogo}
                    alt="Default profile"
                  />
                )}
              </button>

              {/* Dropdown Menu */}
              {isDropdownOpen && (
                <div
                  className="z-50 absolute right-4 top-12 my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600 lg:mr-20 md:mr-40 sm:mr-8"
                  id="dropdown-user"
                >
                  <ul className="py-1">
                    <li>
                      <button
                        onClick={() => navigate("/profile")}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        Profile
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={handleLogout}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        Log out
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar */}
      <aside
        id="logo-sidebar"
        className={`fixed top-0 left-0 z-40 w-64 h-screen pt-20 transition-transform bg-white border-r border-gray-200 dark:bg-black dark:border-gray-700 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } sm:translate-x-0`}
        aria-label="Sidebar"
      >
        <div className="h-full px-3 pb-4 overflow-y-auto bg-white dark:bg-black">
          <ul className="space-y-2 font-medium">
            <li>
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  `flex items-center p-2 rounded-lg ${
                    isActive
                      ? "bg-[#B1D4E0]-100 dark:bg-[#B1D4E0] text-gray-900 dark:text-black"
                      : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                  }`
                }
              >
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                  <img
                    src={dashboard} // Replace with the actual image path
                    alt="Profile"
                    className="w-6 h-6 rounded-full" // Ensures the image itself is circular
                  />
                </div>
                <span className="ms-3">Dashboard </span>
              </NavLink>
            </li>

            {admin && (
              <li>
                <NavLink
                  to="/add-user"
                  className={({ isActive }) =>
                    `flex items-center p-2 rounded-lg ${
                      isActive
                        ? "bg-[#B1D4E0]-100 dark:bg-[#B1D4E0] text-gray-900 dark:text-black"
                        : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                    }`
                  }
                >
                  <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                    <img
                      src={addUser} // Replace with the actual image path
                      alt="Profile"
                      className="w-6 h-6 rounded-full" // Ensures the image itself is circular
                    />
                  </div>
                  <span className="ms-3">Add User </span>
                </NavLink>
              </li>
            )}
            {admin && (
              <li>
                <NavLink
                  to="/user-list"
                  className={({ isActive }) =>
                    `flex items-center p-2 rounded-lg ${
                      isActive
                        ? "bg-[#B1D4E0]-100 dark:bg-[#B1D4E0] text-gray-900 dark:text-black"
                        : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                    }`
                  }
                >
                  <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                    <img
                      src={user} // Replace with the actual image path
                      alt="Profile"
                      className="w-6 h-6 rounded-full" // Ensures the image itself is circular
                    />
                  </div>
                  <span className="ms-3">User List</span>
                </NavLink>
              </li>
            )}
            {admin && (
              <li>
                <NavLink
                  to="/menu-description"
                  className={({ isActive }) =>
                    `flex items-center p-2 rounded-lg ${
                      isActive
                        ? "bg-[#B1D4E0]-100 dark:bg-[#B1D4E0] text-gray-900 dark:text-black"
                        : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                    }`
                  }
                >
                  <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                    <img
                      src={menu} // Replace with the actual image path
                      alt="Profile"
                      className="w-6 h-6 rounded-full" // Ensures the image itself is circular
                    />
                  </div>

                  <span className="ms-3">Menu Details</span>
                </NavLink>
              </li>
            )}
            <li>
              <NavLink
                to="/dish"
                className={({ isActive }) =>
                  `flex items-center p-2 rounded-lg ${
                    isActive
                      ? "bg-[#B1D4E0]-100 dark:bg-[#B1D4E0] text-gray-900 dark:text-black"
                      : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                  }`
                }
              >
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                  <img
                    src={dish1} // Replace with the actual image path
                    alt="Profile"
                    className="w-6 h-6 rounded-full" // Ensures the image itself is circular
                  />
                </div>

                <span className="ms-3">Daily Dish</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/chef"
                className={({ isActive }) =>
                  `flex items-center p-2 rounded-lg ${
                    isActive
                      ? "bg-[#B1D4E0]-100 dark:bg-[#B1D4E0] text-gray-900 dark:text-black"
                      : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                  }`
                }
              >
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                  <img
                    src={chef} // Replace with the actual image path
                    alt="Profile"
                    className="w-6 h-6 rounded-full" // Ensures the image itself is circular
                  />
                </div>

                <span className="ms-3">Chef Suggestion</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  `flex items-center p-2 rounded-lg ${
                    isActive
                      ? "bg-[#B1D4E0]-100 dark:bg-[#B1D4E0] text-gray-900 dark:text-black"
                      : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                  }`
                }
              >
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                  <img
                    src={contact} // Replace with the actual image path
                    alt="Profile"
                    className="w-6 h-6 rounded-full" // Ensures the image itself is circular
                  />
                </div>

                <span className="ms-3">Feedback List</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/category"
                className={({ isActive }) =>
                  `flex items-center p-2 rounded-lg ${
                    isActive
                      ? "bg-[#B1D4E0]-100 dark:bg-[#B1D4E0] text-gray-900 dark:text-black"
                      : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                  }`
                }
              >
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                  <img
                    src={category} // Replace with the actual image path
                    alt="Profile"
                    className="w-6 h-6 rounded-full" // Ensures the image itself is circular
                  />
                </div>
                <span className="ms-3">Add Category</span>
              </NavLink>
            </li>
            <li onClick={handleLogout}>
              <NavLink
                // to="/category"
                className={({ isActive }) =>
                  `flex items-center p-2 rounded-lg ${
                    isActive
                      ? " text-gray-900 dark:text-white"
                      : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                  }`
                }
              >
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                  <img
                    src={logout} // Replace with the actual image path
                    alt="Profile"
                    className="w-6 h-6 rounded-full" // Ensures the image itself is circular
                  />
                </div>
                <span className="ms-3">Log Out</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </aside>
    </div>
  );
};

export default Navbar;
